export const colorConstant = {
  surfaceWhite: "#FFFFFF",
  surfaceBlack: "#0B0B0B",
  surfaceG0: "#F5F5F5",
  surfaceG1: "#E6E6E6",
  surfaceG2: "#BDBDBD",
  surfaceG3: "#949494",
  surfaceG4: "#6B6B6B",
  surfaceG5: "#333333",
  blueB0: "#0860E6",
  blueB1: "#2a71ff",
  blueB2: "#67B5DC",
  blueB4: "#D9F2FF",
  greenG0: "#0B742C",
  greenG1: "#219647",
  greenG4: "#E8FFD8",
  redLight: "#FFE9E9",
  redSolid: "#E90000",
  sandSolid: "#EBA85A",
};
